import styled from '@emotion/styled';
import type { FeatureBlockProps } from '~/editor/blocks/feature/FeatureBlockProps';
import { css_background, css_gap, css_letter, css_medium_up, css_stroke, css_text } from '~/emotion/theme';
import MicrositeSection from '~/components/MicrositeSection';

const Heading = styled.h3`
	margin: 0 0 ${css_gap('section', 2)};
	text-transform: uppercase;
	letter-spacing: ${css_letter('md')};
	font-size: 0.75rem;
	font-weight: 700;
`;

const FeatureList = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: ${css_gap('grid')};
`;

const FeatureChip = styled.div`
	border: 1px solid ${css_stroke()};
	background: ${css_background()};
	box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
	padding: ${css_gap('grid', 2)} ${css_gap()};
	color: ${css_text('weak')};
	text-transform: uppercase;
	letter-spacing: ${css_letter('sm')};
	font-size: 0.625rem;
	font-weight: 600;

	@media (${css_medium_up}) {
		font-size: 0.7rem;
	}
`;

export default function FeatureBlockBeta({ features }: FeatureBlockProps) {
	if (features.length === 0) {
		return null;
	}

	return (
		<MicrositeSection fill padding>
			<Heading>Features</Heading>
			<FeatureList>
				{features.map((feature, index) => (
					<FeatureChip key={index}>{feature}</FeatureChip>
				))}
			</FeatureList>
		</MicrositeSection>
	);
}
